import {
  EMAIL_PATTERN,
  PASSWORD_MAX_SCORE,
  PASSWORD_RULES,
  PASSWORD_SECURE_SCORE,
} from '../constants/auth.constants'

export type PasswordChecks = {
  minLength: boolean
  lowercase: boolean
  uppercase: boolean
  number: boolean
  special: boolean
}

export const isValidEmail = (value: string): boolean => EMAIL_PATTERN.test(value)

export const getPasswordChecks = (password: string): PasswordChecks => ({
  minLength: password.length >= PASSWORD_RULES.MIN_LENGTH,
  lowercase: PASSWORD_RULES.LOWERCASE.test(password),
  uppercase: PASSWORD_RULES.UPPERCASE.test(password),
  number: PASSWORD_RULES.NUMBER.test(password),
  special: PASSWORD_RULES.SPECIAL.test(password),
})

export const getPasswordScore = (password: string): number => {
  if (!password) return 0
  const checks = getPasswordChecks(password)
  let score = 0
  if (checks.minLength) score += 2
  if (checks.lowercase) score += 1
  if (checks.uppercase) score += 1
  if (checks.number) score += 1
  if (checks.special) score += 1
  return Math.min(score, PASSWORD_MAX_SCORE)
}

export const isPasswordSecure = (password: string): boolean =>
  getPasswordScore(password) >= PASSWORD_SECURE_SCORE
